<template>
  <page-wrapper :title="title">
    <div class="wrapper">
      <financial-institution-editor
        v-model="form"
      ></financial-institution-editor>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import FinancialInstitutionEditor from "../components/FinancialInstitutionEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    FinancialInstitutionEditor,
  },
  data() {
    const title = "เพิ่มสถาบันการเงิน"
    const form = {
      name: "",
      code: "",
    }

    return { title, form }
  },
  methods: {
    async createFinancialInstitution() {
      const params = this.form
      const response =
        await baanRueJaiClient.admin.financialInstitution.post(params)

      return response
    },
    async handleClickSave() {
      try {
        await this.createFinancialInstitution()
        this.$router.push({ name: "FinancialInstitutionListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
  padding-left: $space;
  padding-right: $space;
}

.editor {
  margin-bottom: $space;
}
</style>
